<template>
  <v-container v-if="reservation" class="pa-0">
    <div>
      <h1>{{ reservation.day }}</h1>
      <h3>{{ reservation.start_time | formatDate }} - {{ reservation.end_time | formatDate }}</h3>
    </div>
    <div class="appointments">
      <p class="location" >{{ reservation.practice.name }} - {{ reservation.room.title }}</p>
      <v-textarea 
        outlined
        auto-grow
        filled
        clear-icon="mdi-close-circle"
        v-model="comment"
      ></v-textarea>

      <v-card-actions class="appt-actions justify-space-around" >
          <v-btn class="btn-confirm" @click="updateReservation(); $router.push({ name: 'my-appointments' })" depressed>
            Wijzigingen opslaan
          </v-btn>

          <v-btn class="btn-delete" @click="deleteReservation(); $router.push({ name: 'my-appointments' })" depressed>
            Verwijder reservering
          </v-btn>
          
          <v-btn class="btn-prev" @click="$router.push({ name: 'my-appointments' })" depressed>
            Terug
          </v-btn>
      </v-card-actions>
    </div>
  </v-container>
</template>

<script>
import BackendService from "../services/BackendService"

export default {
  data: () => ({
    reservation: null,
    comment: "",
  }),
  created() {
    const id = this.$route.params.id
    BackendService.getReservation(id)
      .then((response) => {
        this.reservation = response.data.appointment;
        this.comment = response.data.reservation.comment
      })
      .catch((err) => {~
        console.log(err);
      })
  },
  methods: {
    deleteReservation() {
      const id = this.$route.params.id
      BackendService.deleteReservation(id)
      .then(() => {
        this.$store.dispatch("notification/add", {
          type: "success",
          message: "Reservering verwijderd."
        });
      });
    },
    updateReservation() {
      const id = this.$route.params.id
      let comment = this.comment
      BackendService.updateReservation(id, { comment: comment })
      .then(() => {
        this.$store.dispatch("notification/add", {
          type: "success",
          message: "Wijzigingen opgeslagen"
        });
      });
    }
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        const parts = value.split(":");
        return +parts[0] + ":" + parts[1];
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>

.btn-confirm {
  background: #4caf50 !important;
  margin-left: 0px !important;
  color: #fff !important;
  font-weight: 800 !important;
  margin-bottom: 15px !important;
  text-transform: none !important;
  width: 100%;
}

.btn-delete {
  background: #ff5252 !important;
  margin-left: 0px !important;
  color: #fff !important;
  font-weight: 800 !important;
  margin-bottom: 15px !important;
  text-transform: none !important;
  width: 100%;
}

.btn-prev {
  background: #C0C0C0;
  border: 1px lightgray solid;
  margin-left: 0px !important;
  color: #fff;
  font-weight: 800 !important;
  text-transform: none !important;
  width: 100%;
}

</style>